import { normalizeTransfer } from './normalize-transfer';

export function getCreateTransferRequestParams(transfer) {
  let normalizedTransfer;

  if (transfer.files) {
    normalizedTransfer = normalizeTransfer(transfer);
  }

  let params = {
    message: normalizedTransfer.message,
  };

  // Add email params if it is an e-mail transfer.
  if (normalizedTransfer.type === 'email') {
    params = {
      recipients: normalizedTransfer.recipients,
      message: normalizedTransfer.message,
      from: normalizedTransfer.sender,
    };
  }

  // Are we using a channel?
  if (normalizedTransfer.channel) {
    params['channel'] = normalizedTransfer.channel;
  }

  // Do we have a language?
  if (normalizedTransfer.language) {
    params['ui_language'] = normalizedTransfer.language;
  }

  if (normalizedTransfer.domainUserId) {
    params['domain_user_id'] = normalizedTransfer.domainUserId;
  }

  // Is this a forward? (Forwards don't need filenames)
  if (normalizedTransfer.parent_id) {
    params['parent_id'] = normalizedTransfer.parent_id;
  } else {
    params['files'] = normalizedTransfer.files.map((file) => ({
      name: file.name,
      size: file.size,
      item_type: file.apiType,
    }));
  }

  // Do we have an account id? (Account entity was added in v4 API)
  if (normalizedTransfer.accountId) {
    params['account_id'] = normalizedTransfer.accountId;
  }

  // Do we have a space id?
  if (normalizedTransfer.spaceId) {
    params['space_id'] = normalizedTransfer.spaceId;
  }

  // Only do these for a plus transfer
  if (normalizedTransfer.userType === 'plus') {
    if (normalizedTransfer.password) {
      params['password'] = normalizedTransfer.password;
    }

    // The expiry is one of the few "magic string" values we permit in the UI
    // when creating a transfer, such as "1d", "1w" and so on. The value sent to the server
    // is a String
    params['expire_after_option'] = normalizedTransfer.expiry;
  }

  return params;
}
